import { gql } from '@apollo/client';

export const QUERY_MULTIPLE_BIRTH = gql`
  query multipleBirths {
    multipleBirths {
      id
      name
    }
  }
`;
